export var DisplayType;
(function (DisplayType) {
    DisplayType[DisplayType["Unknown"] = 0] = "Unknown";
    DisplayType[DisplayType["Silverlight"] = 1] = "Silverlight";
    DisplayType[DisplayType["Html"] = 2] = "Html";
    DisplayType[DisplayType["HtmlWithSilverlight"] = 3] = "HtmlWithSilverlight";
    DisplayType[DisplayType["HtmlMobile"] = 4] = "HtmlMobile";
    DisplayType[DisplayType["HtmlTablet"] = 5] = "HtmlTablet";
})(DisplayType || (DisplayType = {}));
;
